import { getApiKey } from "./apiKey";
export const isLogin = () => {
  if (getApiKey()) {
    return true;
  }
  return false;
};
